import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-table-budget-name-renderer",
  templateUrl: "./budget-name-renderer.component.html",
})
export class BudgetNameRendererComponent implements ICellRendererAngularComp {
  name!: string;
  amount!: number;
  interval!: string;

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams) {
    this.name = params.data.name || "Unavailable budget name";
    this.amount = params.data.amount || "Unavailable budget amount";
    this.interval = params.data.interval || "Unavailable interval";
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
